import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';

import BlueHeader from '../common/inputs/blueHeader';
import Select from '../common/inputs/select';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import SelectWithTextBoxInput from '../common/inputs/selectWithTextBoxInput';

const RevisionsHeader = props => {
  const {
    filterValues,
    onChangeFilter,
    modelsData
  } = props;
  return (
    <div className="entity_header supervisors_admin_revision_panel_container_header_revisions">
      <div className='entity_title'>
        <BlueHeader
          labelLocale={<FormattedMessage id="supervisorsAdminRevisionPanel.revisionsListHeader"/>}
          className="supervisors_admin_revision_panel_revisions_history_header"
        />
      </div>
      <SelectWithTextBoxInput
        values={filterValues["model_revisions_filter"]}
        onClickOption={onChangeFilter}
        addSelectLocale={ intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelsRevisionsFilterLabel" })}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsData, "id", "name", false)}
        onClearTextCallback={onChangeFilter}
        data-path={"model_revisions_filter"}
        allowDisplayOptionsButton={true}
      />
      <Select 
        value={filterValues["model_states_filter"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="supervisorsAdminRevisionPanel.statesRevisionsFilterLabel"/>}
        options={InterfaceTooling.getSelectArray("supervisorsAdmin.revisionStatusFilter", "supervisorsAdminRevisionPanel.revision_states_filter")}
        data-path="model_states_filter"
      />
    </div>
  );
};

export default RevisionsHeader;



// WEBPACK FOOTER //
// ./source/client/components/supervisorsAdminRevisionPanel/revisionsHeader.jsx